module.exports = __webpack_public_path__ + "img/shw_fitt.2139b464.png";